"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Header = exports.FullWidthCardContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _HBIconButton = _interopRequireDefault(require("../HBIconButton/HBIconButton"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _breakpoints = require("../../styles/breakpoints");
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var _HBLoadingSkeleton = _interopRequireDefault(require("../HBLoadingSkeleton/HBLoadingSkeleton"));
var _ExclamationMarkTriangle = _interopRequireDefault(require("@honeybook/icons/dist/icons/ExclamationMarkTriangle24"));
var _HBLinkButton = _interopRequireDefault(require("../HBLinkButton/HBLinkButton"));
var _HBTooltip = _interopRequireDefault(require("../HBTooltip/HBTooltip"));
var _InfoCircle = _interopRequireDefault(require("@honeybook/icons/dist/icons/InfoCircle16"));
var _HBClickable = _interopRequireDefault(require("../HBClickable/HBClickable"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Config - Card sizes

var sizes = {
  sm: {
    headerTextType: 'title16',
    headerHeight: '30px',
    headerTopRowGap: '8px',
    headerMarginBlock: '12px',
    contentMarginBlock: '16px',
    paddingInline: '16px',
    iconSize: '24px',
    titleVerticalPadding: '8px'
  },
  md: {
    headerTextType: 'title18',
    headerTopRowGap: '8px',
    headerHeight: '36px',
    headerMarginBlock: '16px',
    contentMarginBlock: '24px',
    paddingInline: '24px',
    iconSize: '24px',
    titleVerticalPadding: '8px'
  },
  lg: {
    headerTextType: 'title20',
    headerHeight: '42px',
    headerTopRowGap: '12px',
    headerMarginBlock: '20px',
    contentMarginBlock: '32px',
    paddingInline: '32px',
    iconSize: '42px',
    titleVerticalPadding: '12px'
  }
};
function HeaderAction(_ref) {
  var headerAction = _ref.headerAction,
    size = _ref.size,
    testIdName = _ref.testIdName;
  if (!headerAction) {
    return null;
  }
  if (headerAction.type === 'link-button') {
    return /*#__PURE__*/_react["default"].createElement(_HBLinkButton["default"], _objectSpread(_objectSpread({}, headerAction.linkButtonProps), {}, {
      testIdName: "".concat(testIdName, "-header-link-button"),
      size: size
    }), headerAction.linkText);
  }
  if (headerAction.type === 'icon-button') {
    return /*#__PURE__*/_react["default"].createElement(_HBIconButton["default"], (0, _extends2["default"])({}, headerAction.iconButtonProps, {
      size: size,
      testIdName: "".concat(testIdName, "-header-icon-button")
    }));
  }
  return /*#__PURE__*/_react["default"].createElement(HeaderActionContainer, null, headerAction.content);
}
function ErrorState(_ref2) {
  var errorMessage = _ref2.errorMessage;
  return /*#__PURE__*/_react["default"].createElement(ErrorStateContainer, null, /*#__PURE__*/_react["default"].createElement(_ExclamationMarkTriangle["default"], {
    color: _colors["default"].textSecondary
  }), /*#__PURE__*/_react["default"].createElement(ErrorStateText, null, /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
    type: "body14",
    color: "textSecondary"
  }, errorMessage || 'Something went wrong.')));
}
function HeaderTitle(_ref3) {
  var title = _ref3.title,
    size = _ref3.size,
    headerIcon = _ref3.headerIcon,
    tooltipText = _ref3.tooltipText,
    testIdName = _ref3.testIdName,
    onHeaderTitleClick = _ref3.onHeaderTitleClick;
  return /*#__PURE__*/_react["default"].createElement(TitleAndIconContainer, {
    size: size
  }, headerIcon && /*#__PURE__*/_react["default"].createElement(IconWrapper, null, headerIcon), onHeaderTitleClick ? /*#__PURE__*/_react["default"].createElement(ClickableTitle, {
    testIdName: "".concat(testIdName, "-clickable-card-header-title'"),
    onClick: onHeaderTitleClick
  }, /*#__PURE__*/_react["default"].createElement(Title, {
    type: sizes[size].headerTextType
  }, title)) : /*#__PURE__*/_react["default"].createElement(Title, {
    type: sizes[size].headerTextType
  }, title), tooltipText && /*#__PURE__*/_react["default"].createElement(_HBTooltip["default"], {
    target: /*#__PURE__*/_react["default"].createElement(InfoCircleIcon, {
      color: _colors["default"].neutral500
    }),
    placement: "top",
    maxWidth: "233px"
  }, tooltipText));
}
var HBCard = function HBCard(_ref4) {
  var title = _ref4.title,
    _ref4$size = _ref4.size,
    size = _ref4$size === void 0 ? 'md' : _ref4$size,
    headerIcon = _ref4.headerIcon,
    className = _ref4.className,
    headerAction = _ref4.headerAction,
    _ref4$withDivider = _ref4.withDivider,
    withDivider = _ref4$withDivider === void 0 ? false : _ref4$withDivider,
    _ref4$withBoxShadow = _ref4.withBoxShadow,
    withBoxShadow = _ref4$withBoxShadow === void 0 ? true : _ref4$withBoxShadow,
    _ref4$withHeader = _ref4.withHeader,
    withHeader = _ref4$withHeader === void 0 ? !!title : _ref4$withHeader,
    testIdName = _ref4.testIdName,
    loadingProps = _ref4.loadingProps,
    children = _ref4.children,
    subtitle = _ref4.subtitle,
    tooltipText = _ref4.tooltipText,
    onHeaderTitleClick = _ref4.onHeaderTitleClick;
  var content = function () {
    if ((loadingProps === null || loadingProps === void 0 ? void 0 : loadingProps.loadingState) === 'loading') {
      return /*#__PURE__*/_react["default"].createElement(_HBLoadingSkeleton["default"], loadingProps === null || loadingProps === void 0 ? void 0 : loadingProps.skeletonProps);
    }
    if ((loadingProps === null || loadingProps === void 0 ? void 0 : loadingProps.loadingState) === 'error') {
      return /*#__PURE__*/_react["default"].createElement(ErrorState, {
        errorMessage: loadingProps === null || loadingProps === void 0 ? void 0 : loadingProps.errorMessage
      });
    }
    return children;
  }();
  var shouldRenderHeader = withHeader && !!title;
  return /*#__PURE__*/_react["default"].createElement(Card, {
    size: size,
    $withBoxShadow: withBoxShadow,
    className: className
  }, shouldRenderHeader && /*#__PURE__*/_react["default"].createElement(Header, {
    size: size
  }, /*#__PURE__*/_react["default"].createElement(HeaderTitleAndActionContainer, {
    size: size,
    isCustomHeaderAction: (headerAction === null || headerAction === void 0 ? void 0 : headerAction.type) === 'custom'
  }, /*#__PURE__*/_react["default"].createElement(HeaderTitle, {
    testIdName: testIdName,
    title: title,
    size: size,
    headerIcon: headerIcon,
    tooltipText: tooltipText,
    onHeaderTitleClick: onHeaderTitleClick
  }), /*#__PURE__*/_react["default"].createElement(HeaderAction, {
    size: size,
    headerAction: headerAction,
    testIdName: testIdName
  })), subtitle && /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
    type: "body14",
    color: "textSecondary"
  }, subtitle)), shouldRenderHeader && withDivider && /*#__PURE__*/_react["default"].createElement(Divider, {
    size: size
  }), /*#__PURE__*/_react["default"].createElement(ContentContainer, {
    shouldRenderHeader: shouldRenderHeader,
    size: size,
    withDivider: withDivider
  }, content));
};
var _default = exports["default"] = HBCard; // -------------------------------- Styles -------------------------------- //
var Card = _styledComponents["default"].div.withConfig({
  displayName: "HBCard__Card",
  componentId: "sc-y3h8n3-0"
})(["display:flex;flex-direction:column;background:#ffffff;border-radius:4px;height:100%;width:100%;", " ", ";"], function (_ref5) {
  var size = _ref5.size;
  return (0, _styledComponents.css)(["padding-inline:", ";"], sizes[size].paddingInline);
}, function (_ref6) {
  var $withBoxShadow = _ref6.$withBoxShadow;
  return $withBoxShadow && (0, _styledComponents.css)(["box-shadow:0px 1px 3px rgba(0,18,71,0.16);"]);
});
var mediumUpHeader = (0, _styledComponents.css)(["justify-content:space-between;flex-direction:row;align-items:center;"]);
var Header = exports.Header = _styledComponents["default"].div.withConfig({
  displayName: "HBCard__Header",
  componentId: "sc-y3h8n3-1"
})(["display:flex;flex-direction:column;gap:4px;", ""], function (_ref7) {
  var size = _ref7.size;
  return (0, _styledComponents.css)(["margin:", " 0;", "{margin:", " 0;}"], sizes[size].headerMarginBlock, _breakpoints.mediumUp, sizes[size].headerMarginBlock);
});
var HeaderActionContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBCard__HeaderActionContainer",
  componentId: "sc-y3h8n3-2"
})(["width:max-content;"]);
var HeaderTitleAndActionContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBCard__HeaderTitleAndActionContainer",
  componentId: "sc-y3h8n3-3"
})(["display:flex;flex-direction:column;", " ", "{", "}", ""], function (_ref8) {
  var isCustomHeaderAction = _ref8.isCustomHeaderAction;
  return !isCustomHeaderAction && mediumUpHeader;
}, _breakpoints.mediumUp, mediumUpHeader, function (_ref9) {
  var size = _ref9.size;
  return (0, _styledComponents.css)(["gap:", ";", "{height:", ";}"], sizes[size].headerTopRowGap, _breakpoints.mediumUp, sizes[size].headerHeight);
});
var IconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBCard__IconWrapper",
  componentId: "sc-y3h8n3-4"
})(["i{display:flex;}svg *{fill:", ";}"], _colors["default"].neutral900);
var TitleAndIconContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBCard__TitleAndIconContainer",
  componentId: "sc-y3h8n3-5"
})(["display:flex;align-items:center;", " ", "{min-width:max-content;}"], function (_ref0) {
  var size = _ref0.size;
  return (0, _styledComponents.css)(["gap:", ";"], sizes[size].headerTopRowGap);
}, _breakpoints.mediumUp);
var Title = (0, _styledComponents["default"])(_HBText["default"]).withConfig({
  displayName: "HBCard__Title",
  componentId: "sc-y3h8n3-6"
})([""]);
var Divider = _styledComponents["default"].div.withConfig({
  displayName: "HBCard__Divider",
  componentId: "sc-y3h8n3-7"
})(["height:1px;background-color:", ";", ""], _colors["default"].neutral200, function (_ref1) {
  var size = _ref1.size;
  return (0, _styledComponents.css)(["margin-inline:-", ";"], sizes[size].paddingInline);
});

// The padding logic which looks a bit complex just add padding to both top and bottom in case there is a divider
// and only to the bottom if there isn't a divider
var ContentContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBCard__ContentContainer",
  componentId: "sc-y3h8n3-8"
})(["flex-grow:1;display:flex;flex-direction:column;", ""], function (_ref10) {
  var size = _ref10.size,
    withDivider = _ref10.withDivider,
    shouldRenderHeader = _ref10.shouldRenderHeader;
  var contentMarginBlock = sizes[size].contentMarginBlock;
  return (0, _styledComponents.css)(["margin-top:", ";margin-bottom:", ";"], withDivider || !shouldRenderHeader ? contentMarginBlock : 0, contentMarginBlock);
});
var ErrorStateContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBCard__ErrorStateContainer",
  componentId: "sc-y3h8n3-9"
})(["display:flex;flex-direction:column;align-items:center;gap:8px;justify-content:center;"]);
var ErrorStateText = _styledComponents["default"].div.withConfig({
  displayName: "HBCard__ErrorStateText",
  componentId: "sc-y3h8n3-10"
})(["width:100%;text-align:center;"]);
var FullWidthCardContainer = exports.FullWidthCardContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBCard__FullWidthCardContainer",
  componentId: "sc-y3h8n3-11"
})(["margin-right:auto;margin-left:auto;width:90%;", "{margin-right:initial;margin-left:initial;width:initial;}", ""], _breakpoints.mediumUp, function (_ref11) {
  var marginBottom = _ref11.marginBottom;
  return marginBottom && "margin-bottom: ".concat(marginBottom, ";");
});
var InfoCircleIcon = (0, _styledComponents["default"])(_InfoCircle["default"]).withConfig({
  displayName: "HBCard__InfoCircleIcon",
  componentId: "sc-y3h8n3-12"
})(["display:flex;"]);
var ClickableTitle = (0, _styledComponents["default"])(_HBClickable["default"]).withConfig({
  displayName: "HBCard__ClickableTitle",
  componentId: "sc-y3h8n3-13"
})(["&:hover{text-decoration:underline;}"]);
//# sourceMappingURL=HBCard.js.map